export * from './app-sidebar-footer.component';



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/components/app-sidebar-footer/index.ts